import { render, staticRenderFns } from "./Repository.vue?vue&type=template&id=43886976&scoped=true&"
import script from "./Repository.vue?vue&type=script&lang=js&"
export * from "./Repository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43886976",
  null
  
)

export default component.exports